﻿// © Microsoft Corporation. All rights reserved.

// define function to generate valid rfc4122 "Version 4"-compliant randomized guid value
// http://www.ietf.org/rfc/rfc4122.txt (Section 4.4)

export default function guidGen()
{
    // generate an additional random timestamp-base seed.
    // the Math.random function is itself seeded, but if two clients happen to have
    // seeded their random number generator with the same value, then they will generate
    // duplicate guids and collide. With this added timestamp seed, the first thirteen characters
    // will be adjusted by the timestamp of the call as well, so even if the clients' random number generated
    // are seeded with the same value, they would have to call this method at the EXACT same millisecond
    // to generate the same GUID. Probably not a very high probability.
    var timestampSeed = new Date().getTime();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, getDigit);

    function getDigit(c)
    {
        // generate a random timestmp-seeded hex digit
        var seededRandom = (timestampSeed + Math.random() * 16) % 16 | 0;

        // adjust the timestamp seed so that it changes for the first thirteen characters
        timestampSeed = Math.floor(timestampSeed / 16);

        // if the position is an "x", just use the random number. If it's a "y", we
        // we want to make sure the value is only the lowest three bits of the random
        // number, with a 1 in the 4-bit position. See RFC4122 for more info.
        return (c == 'x' ? seededRandom : (seededRandom & 0x7 | 0x8)).toString(16);
    }
};
